import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { GSDevTools } from 'gsap/GSDevTools';

import Device from '../images/icons/mobile-alt-solid.svg';
import { Container } from './container';
import Layout from './layout';
import Resource from './resource';
import Headline from './headline';
import SEO from './seo';
import { getIndexFromLocation } from '../helper/slug-helper';

gsap.registerPlugin(DrawSVGPlugin);

if (process.env.GATSBY_GSAP_DEVTOOLS === 'true') {
  gsap.registerPlugin(GSDevTools);
}

function SlideLayout({ location, children, openMenu, data, animation }) {
  const index = getIndexFromLocation(location);
  
  useEffect(() => {
    let gsapDevtool;
    if (process.env.GATSBY_GSAP_DEVTOOLS === 'true' && animation) {
      gsapDevtool = GSDevTools.create({ animation: animation, timeScale: 1 });
    }
    return () => {
      gsapDevtool && gsapDevtool.kill();
    };
  }, [animation]);

  return (
    <Layout>
      <SEO
        title={data.titleSeo || 'E-Paper-Qualitäten'}
        description={data.description}
        metaDescription={data.metaDescription}
        image={data.thumbnail}
        pathname={location.pathname}
      />
      <div id="turn-device-notification">
        <div>
          <Device />
          <p className="lead">Die Präsentation funktioniert am besten, wenn Sie ihr Gerät drehen.</p>
        </div>
      </div>
      <Container index={index} openMenu={openMenu}>
        <section>
          <Headline primaryText={data.title} secondaryText={data.subtitle} />
          {children}
          <p>{data.description}</p>
          <Resource basis={data.basis} source={data.source} />
        </section>
      </Container>
    </Layout>
  );
}

SlideLayout.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  openMenu: PropTypes.bool,
  data: PropTypes.shape({
    titleSeo: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    description: PropTypes.string.isRequired,
    metaDescription: PropTypes.string,
    thumbnail: PropTypes.string.isRequired,
    basis: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
  }),
};

export default SlideLayout;
